module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre11",
    attrs: {
      "id": "pgepubid00005"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "calibre14"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0002#PREFACE"
    }
  }, [_vm._v("PREFACE")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/Section0004#I._JOHN_DRYDEN"
    }
  }, [_vm._v("I. JOHN DRYDEN")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0005#II._THE_METAPHYSICAL_POETS",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. THE METAPHYSICAL POETS")]), _c('br', {
    staticClass: "calibre6"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Text/Section0006#III._ANDREW_MARVELL",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. ANDREW MARVELL")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0